//import ClassSupplyDataFunc from "@/pcomponents/common/content/trade/supply/func/data_func";
import strFunc from '@/lib/lyg/string';

class ClassSupplyDataFunc {
  static default_info_data = {
    a_ymd: "",
    a_seq: "",
    a_class_seq: "",
    a_class_name: "",
    a_sort: "",
    a_date: "",
    a_stu_seq: "",
    a_stu_name: "",
    a_responser_seq: "",
    a_responser_name: "",
    a_title: "",
    a_money: "",
    a_discount_money: "",
    a_pay_money: "",
    a_point_money: "",
    a_money_sum: "",
    a_pay_sort: "",
    a_pay_date: "",
    a_pay_is_card: "",
    a_pay_is_make_cash: "",
    a_pay_cash_number: "",
    a_memo: "",
    a_pay_memo: "",
  };
}
export default ClassSupplyDataFunc;